/* eslint-disable no-restricted-syntax,prefer-const,no-unused-vars,no-console */

export default {
    // Global config
    get_api_url: state => state.backend.api_base_url,
    get_app_url: state => state.appUrl,
    // Authentication
    get_current_user: state => state.auth.current_user,
    get_user_role: state => state.auth.access_rights,
    user_has_role: (state, getters) => (roles) => {
        const userRole = getters.get_user_role;
        let hasRole = false;

        if (userRole) {
            if (Array.isArray(roles)) {
                hasRole = roles.indexOf(userRole.name) > -1;
            } else {
                hasRole = userRole.name === roles;
            }
        }
        return hasRole;
    },
    user_is_admin: (state, getters) => getters.user_has_role('admin'),
    user_is_supplier: (state, getters) => getters.user_has_role('supplier'),
    is_authenticated: state => !!state.auth.auth_token,
    user_access_rights: state => state.auth.access_rights,
    get_auth_token: state => state.auth.auth_token,
    get_auth_status: state => state.auth.auth_status,
    get_auth_error: state => state.auth.auth_error,
    show_login_error: state => state.auth.auth_status === 'error',
    // Wordings
    get_wordings: state => state.wordings,
    get_wording: (state, getters) => (key, supplierId) => {
        let wording = null;
        if (state.wordings) {
            if (getters.user_is_admin) {
                const supplierWording = supplierId ? state.wordings[supplierId] || state.wordings.default : state.wordings.default;
                // if there is no key in supplier wordings
                wording = supplierWording[key] || state.wordings.default[key];
            } else {
                wording = state.wordings[key];
            }
        }
        return wording;
    },
    // Order
    get_orders: state => state.orders,
    get_total_orders: state => state.total_orders,
    get_order: (state, getters) => orderId => getters.get_orders.data.filter(order => order.id === orderId)[0],
    // User
    get_users: state => state.users,
    get_user: (state, getters) => (userId) => {
        let user = null;

        if (getters.user_is_admin && userId) {
            user = state.users.filter(one => one.id === parseInt(userId, 10))[0];
        } else {
            user = getters.get_current_user;
        }

        return user;
    },
    // Roles
    get_roles: state => state.roles,
    get_role_id: state => roleName => state.roles.filter(role => role.name === roleName)[0].id,
    get_role_by_id: (state, getters) => (roleId) => {
        if (getters.get_roles) {
            return getters.get_roles.filter(role => role.id === roleId)[0];
        }
        return null;
    },
    // Supplier
    get_suppliers: state => state.suppliers,
    get_supplier: state => (supplierId) => {
        let supplier = null;
        if (supplierId) {
            supplier = state.suppliers.filter(one => one.id === parseInt(supplierId, 10))[0];
        }

        return supplier;
    },
    // Building
    get_buildings: state => state.buildings,
    get_building: state => (buildingId) => {
        let building = null;
        if (buildingId && state.buildings) {
            building = state.buildings.filter(one => one.id === parseInt(buildingId, 10))[0];
        }
        return building;
    },
    // Field
    get_field: () => (building, fieldId) => building.fields.filter(one => one.id === parseInt(fieldId, 10))[0],
    get_field_index: (state, getters) => (field) => {
        if (field.building) {
            return getters.get_building(field.building.id).fields.indexOf(field);
        }
        return 0;
    },
    // Panel
    get_panel: (state, getters) => (buildingId, fieldId, panelId) => {
        const building = getters.get_building(buildingId);
        const field = getters.get_field(building, fieldId);
        return field.panels.filter(one => one.id === panelId)[0];
    },
};



// WEBPACK FOOTER //
// ./src/store/getters.js